var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/solid/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Compo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.419 3.67708C16.3218 2.77431 17.7855 2.77431 18.6883 3.67708L20.3229 5.31171C21.2257 6.21449 21.2257 7.67818 20.3229 8.58096L18.8736 10.0303C18.7598 9.97394 18.6401 9.91302 18.516 9.84767C17.6806 9.40786 16.6892 8.79057 15.9493 8.05069C15.2095 7.31082 14.5922 6.31945 14.1524 5.48403C14.087 5.35989 14.0261 5.24018 13.9697 5.12639L15.419 3.67708ZM14.8887 9.11135C15.7642 9.98687 16.8777 10.6759 17.7595 11.1444L12.06 16.8438C11.7064 17.1975 11.2475 17.4269 10.7523 17.4977L7.31963 17.9881C6.5568 18.097 5.90295 17.4432 6.01193 16.6804L6.50231 13.2477C6.57305 12.7525 6.80248 12.2936 7.15616 11.94L12.8556 6.24053C13.3241 7.12234 14.0131 8.23582 14.8887 9.11135ZM3.75 19.5C3.33579 19.5 3 19.8358 3 20.25C3 20.6642 3.33579 21 3.75 21H20.25C20.6642 21 21 20.6642 21 20.25C21 19.8358 20.6642 19.5 20.25 19.5H3.75Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.08a656b4b363de0e75233d3a9e12c286.svg";
export { ForwardRef as ReactComponent };